<template>
  <layout-basic>
    <v-container grid-list-md text-xs-left fluid style="padding: 0px">
      <v-layout row wrap>
        <v-col cols="12" md="4"></v-col>
        <v-col cols="12" md="4">
          <v-card-text class="px-0">
            <h3>User Statistics - Number of Logins by month by all customers</h3>
            <apexchart
              :options="lineChartOptions"
              :series="lineSeries"
              width="100%"
              type="line"
            />
          </v-card-text>
        </v-col>
        <v-col cols="12" md="4"></v-col>
      </v-layout>
      <v-container>
        <v-layout row wrap>
          <v-row style="justify-content: center;">
            <v-col cols="12" sm="6" md="3">
              <v-card
                class="text-xs-center px-0 mx-auto"
                height="100%"
                to="/partner/reports/customer"
              >
                <v-card-text>
                  <v-img
                    width="120px"
                    height="120px"
                    position="center"
                    style="margin: 0 auto"
                    contain
                    src="/static/chart.png"
                  ></v-img>
                  <h3>Customer Reports</h3>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="3" v-if="tier2partner">
              <v-card
                class="text-xs-center px-0 mx-auto"
                height="100%"
                to="/partner/reports/partner"
              >
                <v-card-text>
                  <v-img
                    width="120px"
                    height="120px"
                    position="center"
                    style="margin: 0 auto"
                    contain
                    src="/static/chart.png"
                  ></v-img>
                  <h3>Partners Reports</h3>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-layout>
      </v-container>
    </v-container>
  </layout-basic>
</template>
<script>
import LayoutBasic from '@/layouts/PartnerHub';
import VueApexCharts from 'vue-apexcharts';
import reportAPI from '@/api/report.js';
import partnerAPI from '@/api/partner.js';

export default {
  components: {
    LayoutBasic,
    apexchart: VueApexCharts,
  },
  data() {
    return {
      line: {},
      bar: {},
      pie: {},
      tier2partner: false,
      pieChart: {
        series: [0],
        chartOptions: {
          dataLabels: {
            enabled: false,
          },
          labels: ['Not Started', 'Completed', 'In progress'],
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200,
                },
                legend: {
                  show: false,
                },
              },
            },
          ],
          legend: {
            position: 'right',
            offsetY: 0,
            height: 230,
          },
        },
      },
      lineSeries: [
        {
          name: 'Logins',
          data: [0],
        },
      ],
      lineChartOptions: {
        chart: {
          height: 150,
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'straight',
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'],
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [1],
        },
      },
      companyName: ''
    };
  },
  mounted() {
    this.getReports();
    // this.getPartnerTier();
  },
  computed: {
    lineChartY() {
      return this.line.logins.map((x) => {
        return x;
      });
    },
    lineChartX() {
      return this.line.months.map((x) => {
        return x;
      });
    },
    barSeries() {
      return [
        {
          name: 'Total Users',
          data: this.bar.series,
        },
      ];
    },
    barChartOptions() {
      return {
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        tooltip: {
          enabled: false,
        },
        xaxis: {
          categories: this.bar.categories,
          tickAmount: 3,
          labels: {
            formatter: function (val) {
              return val.toFixed(0);
            },
          },
        },
      };
    },
  },
  methods: {
    lineChart() {
      this.lineChartOptions = {
        xaxis: {
          categories: this.lineChartX,
        },
        chart: {
          toolbar: {
            show: true,
            tools: {
              download: true,
              selection: false,
          zoom: false,
          zoomin: false,
          zoomout: false,
          pan: false,
          reset: false
            },
            export: {
              csv: {
                filename: `User_Statistics_${this.companyName}_${new Date().toISOString().slice(0, 19).replace(/[-T:]/g, "_")}`, // Custom filename with timestamp
                columnDelimiter: ",",
                headerCategory: "Month", // Custom X-axis title
                headerValue:  this.lineSeries[0].name, // Custom Y-axis title
              }
           }
          },
        },
      };
      this.lineSeries = [
        {
          data: this.lineChartY,
        },
      ];
    },
    pieC() {
      this.pieChart = {
        series: this.pie.map((x) => {
          return x;
        }),
      };
    },
    getReports() {
      reportAPI.getReports().then((response) => {
        this.line = response.data.line;
        this.bar = response.data.bar;
        this.pie = response.data.pie;
        this.companyName = response.data.company_name;
        this.lineChart();
        // this.pieC();
      });
    },
  },
};
</script>
